import { useMemoSelector } from '@spa/redux/hooks'
import {
  contractsSelectors,
  usePlanningPolicies
} from '@spa/scenes/Plannings/redux/selectors'
import { isEqual } from 'lodash-es'
import React from 'react'
import type { PropsWithChildren, ReactElement, ReactNode, FC } from 'react'
import { getCurrentMembershipId } from 'snap-redux/modules/memberships/selectors'

export type Props = {
  contractId: number
  children: ReactNode
}
const ShowEmployeeCounters: FC<PropsWithChildren<Props>> = ({
  children,
  contractId
}) => {
  const currentMembershipId = useMemoSelector(getCurrentMembershipId)
  const contract = useMemoSelector(state =>
    contractsSelectors.getCachedById(state, contractId)
  )

  const policies = usePlanningPolicies()
  const isOwnContract = contract.membership_id === currentMembershipId

  if (
    policies.canSeeCounters ||
    (policies.canSeeOwnCounters && isOwnContract)
  ) {
    return children as ReactElement
  }

  return null
}

export default React.memo(ShowEmployeeCounters, isEqual)
